module.exports = __webpack_public_path__ + "img/esp.50623e6a.svg";